export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "contextWorker.d073d480.worker.js");
}
